'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styles$5 = require('./styles-f287cb5d.js');

var Spinner = function (_a) {
    var size = _a.size, color = _a.color;
    return (React__default.createElement(styles$5.StyledSpinner, { size: size, color: color, viewBox: "0 0 50 50", "data-testid": "spinner" },
        React__default.createElement("circle", { className: "path", cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "4" })));
};

exports.Spinner = Spinner;
